import template from './system_notifications.html';
import tr from '../../lib/default-translator.js';

class SystemNotificationsViewModel
{
	constructor(page)
	{
		this.page = page;
		this.notifications = ko.observableArray([]);
		this.search_string = ko.observable('');

		// filter
		this.notifications_categories = ko.observableArray();
		this.filters = ko.observableArray();

		// pagination
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(20);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([20, 50, 100, 200]);
		this.selected_number_of_records = ko.observable(20);

		// sort
		this.sort_field = ko.observable('date_created');
		this.sort_order = ko.observable('ASC');

		this.search_string.subscribe((val) => {
			this.current_page_number(1);
			this.page.updateData();
		});

		this.filters.subscribe((val) => {
			this.current_page_number(1);
			this.page.updateData();
		});

		this.selected_number_of_records.subscribe((newVal) => {
			localStorage.setItem('selected_number_of_records_system_notifs', this.selected_number_of_records());
			this.current_page_size(newVal);
			this.page.updateData();
		});
	};

	clear_selected_option ()
        {
                this.search_string('');
        }


	back_to_top ()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	show_help()
	{
		Grape.dialog.open('SystemNotificationsHelp', { employee_id: this.page.bindings.id });
	};

	page_click (page_number)
	{
		this.current_page_number(page_number);
		this.page.updateData();
	};

	// Sort fields
	sort_column (column)
	{
		if (this.sort_field() === column)
			this.sort_order(this.sort_order() === 'ASC' ? 'DESC' : 'ASC');
		else
		{
			this.sort_field(column);
			this.sort_order('ASC');
		}
		this.page.updateData();
	};

	async edit_notification(data)
	{
		await Grape.dialog.open('SystemNotificationsAdd', data);
		this.page.updateData();
	};

	async delete_notification(data)
	{
		// set to false to deactivate
		let delete_data = {
			employee_id : data.user_created_id,
			notifications_ids: [data.notifications_id]
		};
		
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this notification entry?')});
			
		if (response)
		{
			let res = await Grape.fetches.postJSON('/notifications/delete_notification', delete_data);

			if (res.status != 'ERROR')
			{
				await Grape.alerts.alert({type: 'success', title: tr('Success'), message: tr('Successfully deleted notification.')});
				this.page.updateData();
			}
			else
				Grape.alerts.apiError(res);
		}
	};

	async send_notification(data)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to send this notification?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/notifications/send_notification', data);

			if (res.status != 'ERROR')
			{
				await Grape.alerts.alert({type: 'success', title: tr('Success'), message: tr('Successfully sent notification.')});
				this.page.updateData();
			}
			else
				Grape.alerts.apiError(res);
		};
	};

	remove_filter(data)
	{
		this.filters.remove(data);
		this.page.updateData();
	};
}

class SystemNotificationsPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new SystemNotificationsViewModel(this);

		let selected_number_of_records = localStorage.getItem('selected_number_of_records_system_notifs');

		if (selected_number_of_records)
		{
			this.viewModel.selected_number_of_records(selected_number_of_records);
			this.viewModel.current_page_size(selected_number_of_records);
		}
	}

	async init()
	{
		document.title = tr('System Notifications');
		let title = tr('System Notifications');
		window.current_page_title(title);

		let result = await Grape.fetches.getJSON('/api/record', {
			table: 'notifications_category',
			schema: 'public',
			limit: 1000000
		});

		if (result.status != 'ERROR')
		{
			let cat = result.records.map((x) => ({
				value: x.notifications_category
			}));
			this.viewModel.notifications_categories(cat);
		}
	}

	async updateData()
	{
		let options = {
			table: 'v_notifications',
			schema: 'savanna',
			filter_join: 'AND',
			limit: this.viewModel.current_page_size(),
			offset: 0,
			sortorder: this.viewModel.sort_order(),
			sortfield: this.viewModel.sort_field(),
			join: 'OR',
			filter: [{
				field: 'active',
				operand: '=',
				value: true
			}]
		}

		// LOGIC: Search
		if (this.viewModel.search_string() != '' && this.viewModel.search_string())
		{
			options.filter.push({
				field: 'subject',
				operand: 'ILIKE',
				value: `%${this.viewModel.search_string()}%`
			});
		}

		// LOGIC: Filter
		if (this.viewModel.filters().length > 0)
		{
			options.filter.push({
				field: 'notifications_category',
				operand: 'IN',
				value: this.viewModel.filters()
			})
		}

		//LOGIC: Pagination
		if (this.viewModel.current_page_number() && this.viewModel.current_page_size())
		{
			options.limit = this.viewModel.current_page_size();
			options.offset = (this.viewModel.current_page_number()-1) * this.viewModel.current_page_size();
		}

		try {
			let result = await Grape.fetches.getJSON('/api/record', options);
			if (result.status != 'ERROR')
			{
				this.viewModel.notifications(result.records);
				this.viewModel.page_count(Math.floor(result.total/result.limit)+1);
				this.viewModel.pagination_summary(`Showing ${options.offset} - ${this.viewModel.current_page_number() * this.viewModel.current_page_size()} of ${result.total} row(s)`);
			}
			else
				throw new Error(result.message || result.code);
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}
		

	};


};

export default {
	route: '[/]admin/system_notifications',
	page_class: SystemNotificationsPage,
	template: template,
	template_filename: 'translation/system_notifications'
};
